import State from 'store/State';
import { selectPortfolioSummaryWidgetState } from 'widgets/portfolioSummary/store/instances/selectors';
import { useSelector } from 'react-redux';

import { initialPortfolioSummaryComponentState } from 'widgets/portfolioSummary/store/instances/component/PortfolioSummaryComponentState';
import { useWidgetContext } from 'widgets/WidgetContext';

export const selectPortfolioSummaryComponentState = (
    state: State,
    widgetKey: string
) => {
    const portfolioSummaryState = selectPortfolioSummaryWidgetState(
        state,
        widgetKey
    );
    return portfolioSummaryState && portfolioSummaryState.component
        ? portfolioSummaryState.component
        : initialPortfolioSummaryComponentState;
};

export const useSelectDrillDown = () => {
    const { widgetKey } = useWidgetContext();
    return useSelector(
        (state: State) =>
            selectPortfolioSummaryComponentState(state, widgetKey).drillDown
    );
};
